import { Method, Request, sendRequest } from "@myloc/myloc-utils";
import { AppDispatch } from "../../../app/store";
import { api } from "../../../config/settings";
import HttpStatusCodes from "../../../utils/HttpStatusCodes";
import { EntityActionReducerBuilderInterface, REQUEST_STATE } from "../../dataTypes";
import { createAsyncThunk } from "../../utils/createAsyncThunk";
import defaultRestOptions from "../../utils/defaultRestOptions";
import { WebOrder, webOrderSliceName, ResponseWebOrder } from "../dataTypes";
import { webOrderAdapter } from "../webOrderAdapter";

async function getWebOrder(dispatch: AppDispatch, id: string) {
  const url = api.webOrder.webOrder(id);
  const request = new Request(url, Method.GET);

  return await sendRequest(request, {}, await defaultRestOptions({ dispatch }));
}

export const fetchWebOrder = createAsyncThunk<ResponseWebOrder, string>(
  webOrderSliceName + "/fetchWebOrder",
  (dispatch, id) => getWebOrder(dispatch, id),
);

export const addFetchWebOrderReducers = (builder: EntityActionReducerBuilderInterface<WebOrder>) => {
  builder.addCase(fetchWebOrder.pending, (state, action) => {
    const id = action.meta.arg;
    const webOrder = state.entities[id] ?? ({ id } as WebOrder);

    webOrderAdapter.upsertOne(state, { ...webOrder, requestState: REQUEST_STATE.PENDING, errorMessage: undefined });
  });
  builder.addCase(fetchWebOrder.fulfilled, (state, action) => {
    const { payload, meta } = action;
    const id = meta.arg;

    webOrderAdapter.updateOne(state, {
      id,
      changes: { ...payload, fetchedTimestamp: Date.now(), requestState: REQUEST_STATE.FULFILLED },
    });
  });
  builder.addCase(fetchWebOrder.rejected, (state, action) => {
    const { payload, meta } = action;

    if (payload) {
      const id = meta.arg;

      if (payload.httpStatusCode === HttpStatusCodes.NOT_FOUND) webOrderAdapter.removeOne(state, id);
      else
        webOrderAdapter.updateOne(state, {
          id,
          changes: { requestState: REQUEST_STATE.REJECTED, errorMessage: payload.message },
        });
    }
  });
};
